<template>
  <v-app>
    <AppBarAndNavigationDrawer />

    <v-main class="app">
      <router-view />
    </v-main>

    <Footer />
  </v-app>
</template>

<script>
import AppBarAndNavigationDrawer from '../components/AppBarAndNavigationDrawer'
import Footer from '@/componentes/Footer'

export default {
  name: 'Layout',
  components: { AppBarAndNavigationDrawer, Footer },
}
</script>

<style>
.app {
  background-color: var(--v-background-base);
}
</style>
